<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/setting-department">
                    <icon name="users"></icon>
                    ตั้งค่าแผนก
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/setting-position">
                    <icon name="user-tag"></icon>
                    ตั้งค่าตำแหน่ง
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/setting-tax-rate">
                    <icon name="coins"></icon>
                    ปรับเงินภาษี
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/setting-social-security-rate">
                    <icon name="coins"></icon>
                    ตั้งค่าเงินประกันสังคม
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "setting-employee-layout"
    }
</script>

<style scoped>

</style>
